import { Float,Environment, OrbitControls, PresentationControls } from '@react-three/drei'
import './style.css'; // Import your CSS file
import { AmbientLight } from 'three';
import  Model from './Model.jsx'
import { Html } from '@react-three/drei'
import { MeshBasicMaterial } from 'three'
import { useState,useEffect } from 'react'
export default function Experience()
{
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    let modelScale;

    if (windowWidth < 400) {
        modelScale = 0.27;
    } else if (windowWidth < 550) {
        modelScale = 0.25;
    } else if (windowWidth < 650) {
        modelScale = 0.3;
    } else if (windowWidth < 900) {
        modelScale = 0.4; // Adjust as needed
    } else {
        modelScale = 0.5; // Default scale if none of the conditions match
    }

    
    return <>
        
        
        
        
        
        <directionalLight 
      
        position={[0,1,0]} 
        castShadow 
        intensity={0.3}
        shadow-mapSize={[2048,2048]} 
        shadow-camera-near={0.1}
        shadow-camera-far={10}
        />
        
        
        <PresentationControls  
        global
        
        polar={[-0.01, 0.01]}
        config={{mass:2, tension:400}}
        >
                <Model scale={modelScale} position={[0,-0.7,0]}/>
                
        </PresentationControls>
        
        
    </>
}